namespace GeniuzPOS.PosShift {
    export class PsVatRefundDtColumns {
        static columnsKey = 'PosShift.PsVatRefundDt';
    }
}
